import { useMemo } from "react";
import { useMapStore } from "../../stores/map/useMapStore";
import { usePontos } from "../pontos/usePontos";
import { useTripPositionsAnalysis } from "../analysis/useTripPositionsAnalysis";
import { useTripStatusAnalysis } from "../analysis/useTripStatusAnalysis";
import { useLine } from "../lines/useLines";
import { useTrip } from "../trips/useTrip";

export function useMapData() {

    const codigoMap = useMapStore(state => state.codigoMap);
    const tripUidMap = useMapStore(state => state.tripUidMap);
    const trajeto = useMapStore(state => state.trajeto);
    const route = useMapStore(state => state.route);
    const mapFocus = useMapStore(state => state.mapFocus);
    const selectedPoint = useMapStore(state => state.selectedPoint);
    const modeMap = useMapStore(state => state.modeMap);
    const openMap = useMapStore(state => state.openMap);
    const positionsRange = useMapStore(state => state.positionsRange);
    const lastPosition = useMapStore(state => state.lastPosition);
    const mapReady = useMapStore(state => state.mapReady);
    const pezinho = useMapStore(state => state.pezinho);

    const isTripMode = modeMap === 'trip';

    const pontos = usePontos(codigoMap);

    const line = useLine(codigoMap);

    const trip = useTrip(
        isTripMode
            ? tripUidMap
            : null
    );

    const dataHoraIniTrip = trip?.DATAHORA_INICIAL_PREVISTO;

    
    const positionsAnalysis =
        useTripPositionsAnalysis(
            trip?.DATA_REFERENCIA,
            isTripMode
                ? codigoMap
                : null
        );
        
    const pontosAnalysis = positionsAnalysis?.resultado;

    const tripStatus =
        useTripStatusAnalysis(
            trip?.DATA_REFERENCIA,
            isTripMode
                ? codigoMap
                : null,
            trip?.DATAHORA_FINAL_PREVISTO
        );

    const situacao = tripStatus;

    const pontosList = useMemo(() => {
        
        return (pontos ?? [])
            .filter(p =>
                p?.pontoReferencia?.LATITUDE != null &&
                p?.pontoReferencia?.LONGITUDE != null
            )
            .sort((a, b) =>
                Number(a.SEQUENCIA) -
                Number(b.SEQUENCIA)
            );

    }, [pontos]);

    const plannedTrajeto = useMemo(() => {

        const coords = trajeto
            .filter(p =>
                p?.lat != null &&
                p?.lng != null
            )
            .map(p => [
                Number(p.lat),
                Number(p.lng)
            ]);

        if (!coords.length || !pontosList.length) {
            return coords;
        }

        const next = [...coords];

        const first = pontosList[0];
        const last = pontosList[pontosList.length - 1];

        next[0] = [
            Number(first.pontoReferencia.LATITUDE),
            Number(first.pontoReferencia.LONGITUDE)
        ];

        next[next.length - 1] = [
            Number(last.pontoReferencia.LATITUDE),
            Number(last.pontoReferencia.LONGITUDE)
        ];

        return next;

    }, [trajeto, pontosList]);

    const realPositions = useMemo(() => {

        return positionsRange
            .filter(position =>
                position?.latitude != null &&
                position?.longitude != null
            )
            .map(position => ({
                ...position,
                latitude: Number(position.latitude),
                longitude: Number(position.longitude)
            }));

    }, [positionsRange]);

    const realTrajeto = useMemo(() => {

        return realPositions.map(position => [
            position.latitude,
            position.longitude
        ]);

    }, [realPositions]);

    return {
        openMap,
        line,
        trip,
        codigoMap,
        tripUidMap,
        pontos,
        pontosList,
        plannedTrajeto,
        realPositions,
        realTrajeto,
        route,
        mapFocus,
        selectedPoint,
        modeMap,
        pezinho,
        pontosAnalysis,
        situacao,
        dataHoraIniTrip,
        lastPosition,
        mapReady
    }
}
